export default function CTA() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#1e3a8a] via-[#2563eb] to-[#1e3a8a]">
      <div className="max-w-5xl mx-auto px-4 text-center text-white">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          목형 제작 문의
        </h2>
        <p className="text-xl mb-10 text-white/90 leading-relaxed">
          30년 전통의 기술력으로 최고 품질의 목형을 제작해드립니다.<br />
          소량 제작부터 대량 생산까지 언제든지 상담해주세요.
        </p>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
            <div className="w-14 h-14 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-phone-fill text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold mb-2">전화 문의</h3>
            <a href="tel:02-2263-8248" className="text-2xl font-bold text-[#D4AF37] hover:text-[#C19B2B] transition-colors cursor-pointer">
              02-2263-8248
            </a>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
            <div className="w-14 h-14 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-mail-fill text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold mb-2">이메일 문의</h3>
            <a href="mailto:jk8248@hanmail.net" className="text-lg text-white/90 hover:text-white transition-colors cursor-pointer break-all">
              jk8248@hanmail.net
            </a>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
            <div className="w-14 h-14 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-printer-fill text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold mb-2">팩스 문의</h3>
            <p className="text-lg text-white/90">
              02-2263-3616
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/quote"
            className="inline-flex items-center justify-center gap-2 bg-[#D4AF37] hover:bg-[#C19B2B] text-white px-10 py-5 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
          >
            <i className="ri-file-text-line text-xl"></i>
            온라인 견적 문의
          </a>
          <a
            href="/contact"
            className="inline-flex items-center justify-center gap-2 bg-white hover:bg-gray-100 text-[#1e3a8a] px-10 py-5 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
          >
            <i className="ri-map-pin-line text-xl"></i>
            오시는 길
          </a>
        </div>
      </div>
    </section>
  );
}
